import Image from "next/image";
import { staticLoader } from "../../lib/helpers/imageLoader";
import styles from './Trends.module.css'
import { useGlobalContext } from "../../lib/context";

type Props = {
    h1text?: string
    h2text?: string
}
export function TrendsBanner({ h1text, h2text }: Props) {
    const { props: { isMobileView } } = useGlobalContext()
    return (
      <div className={styles.incoBannersection}>
        <div className="container">
          <div className={`${styles.incoBannerMain}`}>
            <div className={styles.leftTextBox}>
              <h1 className="font46 f900 text222 mb16  lineHeight46">
                {h1text ? h1text.replace( /(<([^>]+)>)/ig, '') : "Interior Design Trends"}
              </h1>
              <p className="font16 text222">
                {h2text
                  ? h2text.replace( /(<([^>]+)>)/ig, '')
                  : "Channeling sublime designs, one trend at a time."}
              </p>
            </div>
            <div className={styles.rightImgBox}>
              <Image
                priority
                className="img-responsive"
                src="/assets/images/trendsBanner.svg"
                alt="Incotrendsbanner"
                width={isMobileView ? 220 : 343}
                height={220}
                loader={staticLoader}
              />
            </div>
          </div>
        </div>
      </div>
    );
}